module.exports = __webpack_public_path__ + "img/yjfl.33ff9e52.png";